module.exports = __webpack_public_path__ + "img/translationeditor_10.2d9db14b.jpg";